import React from 'react';
import { Page } from '@fiverr-private/perseus';
import tracker from '../service/tracker';
import CategoryPage from '../components/CategoryPage';
import { CategoryClientPropTypes } from '../types';

class CategoryClient extends Page {

    componentDidMount() {
        const { id: categorySlug, loggedIn, category } = this.props;
        tracker.view(categorySlug, category.title, loggedIn);
    }

    render() {

        const {
            isTouch,
            category,
            abTests,
            id: categorySlug
        } = this.props;


        return (
            <CategoryPage isTouch={isTouch} category={category} categorySlug={categorySlug} abTests={abTests}/>
        );
    }
}

CategoryClient.propTypes = CategoryClientPropTypes;

export default CategoryClient;

